import { makeStyles } from 'tss-react/mui';
import { CHAT_HEADER_MAX_HEIGHT } from '../../../../../ChatHeaderTemplate/ChatHeaderTemplate';
import { CHAT_CONFIG_VIEW_CONTENT_HEIGHT, CHAT_FOOTER_HEIGHT } from '../../utils/styles.const';

export const useChatPrivateFormContentStyles = makeStyles()((theme) => ({
  list: {
    height: CHAT_CONFIG_VIEW_CONTENT_HEIGHT,

    [theme.breakpoints.down('sm')]: {
      height: `calc(98% - ${CHAT_HEADER_MAX_HEIGHT} - ${CHAT_FOOTER_HEIGHT})`,
    },
  },
}));
